import React, { useState } from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { StackedBarData } from '../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { Column } from '../../../../../../CommonComponents/OPL/Grid/Column';
import { Grid } from '../../../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../../../CommonComponents/OPL/Grid/Row';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { BucketData } from '../../useAssetBucketingResults';
import { FullBreakdown } from '../FullBreakdown/FullBreakdown';
import { NetWorth } from '../NetWorth/NetWorth';
import { NetWorthMakeup } from '../NetWorthMakeup/NetWorthMakeup';
import { SpectrumArrow } from '../SpectrumArrow/SpectrumArrow';
import { Buckets } from '../Buckets/Buckets';

interface BreakdownProps {
  title: string;
  description: string;
  networthMakeup: StackedBarData;
  buckets: BucketData[];
  networthAmount?: number;
  onNetworthClick?: () => void;
  showFullBreakdown?: boolean;
  isDefaultAssetBucketingLayout: boolean;
  hasExcludedFromNetworth?: boolean;
}

export const Breakdown: React.FC<BreakdownProps> = ({
  title,
  description,
  networthMakeup,
  buckets,
  networthAmount,
  onNetworthClick,
  showFullBreakdown = false,
  isDefaultAssetBucketingLayout,
  hasExcludedFromNetworth = false,
}) => {
  const [showFullBreakdownModal, setShowFullBreakdownModal] = useState(false);

  return (
    <>
      <Text fontSize="h3" fontWeight={600} mt="24">
        {title}
      </Text>

      <Text color="neutral.600" mt="8">
        {description}
      </Text>

      <Grid gutter={24} mt="24">
        <Row mb="24">
          <Column width={4}>
            <NetWorth amount={networthAmount} onClick={onNetworthClick} />
          </Column>

          <Column width={8}>
            <Card p="32" height="100%">
              <Text fontSize="h5" fontWeight={600} mb="12">
                Your Net Worth Makeup
              </Text>

              <NetWorthMakeup data={networthMakeup} />
            </Card>
          </Column>
        </Row>

        <Buckets buckets={buckets} />
      </Grid>

      {hasExcludedFromNetworth && (
        <Text fontSize="small" py="8">
          *Non balance sheet items will not contribute to Net Worth.
        </Text>
      )}

      {showFullBreakdown && (
        <>
          <Box display="flex" mt="24" justifyContent="center">
            <Button variant="link" onClick={() => setShowFullBreakdownModal(true)}>
              See full breakdown
            </Button>
          </Box>

          {showFullBreakdownModal && (
            <FullBreakdown
              networthAmount={networthAmount}
              networthMakeup={networthMakeup}
              buckets={buckets}
              onClose={() => setShowFullBreakdownModal(false)}
            />
          )}
        </>
      )}

      {isDefaultAssetBucketingLayout && <SpectrumArrow mt="24" />}
    </>
  );
};
